define(function(require) {
    var $ = require("jquery");
    var util = require("@modules/utils");
    function highlightHelpLoggingInFields() {
        // prevent .parent().parent() without classes from messing up other pages
        if ($("span.field-validation-error").closest(".enrollment-step").length > 0) return;
        // vvv--- better to scope this to a parent class or Id
        $('span.field-validation-error:visible').each(function (index, element) {
            $(element).parent().parent().addClass('is-error');
            $(element).parent().addClass('is-error');
            $(element).parent('.form-item-group').parent().addClass('is-error');
            $(element).parent().parent().find('span.filter-option').addClass('is-error');
            $(element).parent().find('input').attr('aria-labelledby', $(element).attr('id')).attr('aria-invalid', 'true');
            $(element).parent().find('div.btn-group').find('select').attr('aria-labelledby', $(element).attr('id')).attr('aria-invalid', 'true');
        });
    }

    function undoHelpLoggingInFieldHighlights() {
        // prevent .parent().parent() without classes from messing up other pages
        if ($("span.field-validation-error").closest(".enrollment-step").length > 0) return;
        // vvv--- better to scope this to a parent class or Id
        $('span.field-validation-error').each(function (index, element) {
            $(element).parent().parent().removeClass('is-error');
            $(element).parent().removeClass('is-error');
            $(element).parent('.form-item-group').parent().removeClass('is-error');
            $(element).parent().parent().find('span.filter-option').removeClass('is-error');
            $(element).parent().find('input').attr('aria-labelledby', $(element).parent().parent().find('label').attr('id')).attr('aria-invalid', 'false');
            $(element).parent().find('div.btn-group').find('select').attr('aria-labelledby', $(element).parent().parent().find('label').attr('id')).attr('aria-invalid', 'false');
        });
    }

    undoHelpLoggingInFieldHighlights();
    highlightHelpLoggingInFields();

    function createValidationSummary(formId, errorMessageCount) {
        $('div.validation-summary-errors').remove();
        var errorMessages = $('span.field-validation-error:visible').map(function () {
            return $.trim($(this).text());
        }).get();

        var valueToRemove = "";

        errorMessages = $.grep(errorMessages, function (value) {
            return value !== valueToRemove;
        });

        errorMessageCount = errorMessageCount || $(errorMessages).length;
        var $form = $('form#' + formId);
        var listHtml = "";
        $form.before("<div id='javascriptValidationSummary' class='validation-summary-errors form-error-text'>");

        listHtml += "<strong id='javascriptValidationCount' class='form-error-text'>" + errorMessageCount + $('.hidden.validation-error-count').html() + "</strong>";
        listHtml += "<ul id='javascriptValidationUl'>";
        $(errorMessages).each(function (index, element) {
            listHtml += ("<li>" + element + "</li>");
        });
        listHtml += "</ul>";
        $(listHtml).appendTo('#javascriptValidationSummary');
    }

    undoHelpLoggingInFieldHighlights();
    highlightHelpLoggingInFields();

    $('#passwordStepOneSubmit').click(function(e) {
        undoHelpLoggingInFieldHighlights();

        var isValid = true;

        $('span.field-validation-error.form-error-hint').hide();

        var email = $('#email');
        var username = $('#username').val();
        var monthOfBirth = $('#date-month').val();
        var dayOfBirth = $('#date-day').val();
        var yearOfBirth = $('#date-year').val();
        var monthDayRegex = /^\d{1,2}$/;
        var yearRegex = /^\d{4}$/;

        if (!username) {
            isValid = false;
            $('#usernameError').show();
        }

        if (monthOfBirth !== null) {
            monthOfBirth = $.trim(monthOfBirth);
        }
        if (dayOfBirth !== null) {
            dayOfBirth = $.trim(dayOfBirth);
        }
        if (yearOfBirth !== null) {
            yearOfBirth = $.trim(yearOfBirth);
        }

        var maxYear = new Date().getFullYear();
        if ($('#date-month').length > 0
                && (!yearOfBirth
                    || !yearRegex.test(yearOfBirth)
                    || yearOfBirth > maxYear
                    || yearOfBirth < 1900
                    || !monthOfBirth
                    || !monthDayRegex.test(monthOfBirth)
                    || monthOfBirth > 12
                    || monthOfBirth < 1
                    || !dayOfBirth
                    || !monthDayRegex.test(dayOfBirth)
                    || dayOfBirth > 31
                    || dayOfBirth < 1
                )) {
            isValid = false;
            $('#dateOfBirthError').show();
        }

        if (email.length > 0 && (!util.isValidEmail(email.val()))) {
            isValid = false;
            $('#caregiverEmailError').show();
        }

        if (isValid) {
            undoHelpLoggingInFieldHighlights();
            $('javascriptValidationSummary').remove();
        } else {
            e.preventDefault();
            highlightHelpLoggingInFields();
            createValidationSummary("passwordReset1");
            $('html,body').animate({ scrollTop: 0 }, 'slow');
        }
    });

    $('#passwordStepTwoSubmit').click(function(e) {
        undoHelpLoggingInFieldHighlights();
        var isValid = true;

        $('span.field-validation-error.form-error-hint').hide();

        if ($('#answer').length > 0 && !$('#answer').val()) {
            isValid = false;
            $('#secretAnswerError').show();
        }

        if (isValid) {
            undoHelpLoggingInFieldHighlights();
            $('javascriptValidationSummary').remove();
        } else {
            e.preventDefault();
            highlightHelpLoggingInFields();
            createValidationSummary("passwordReset2");
        }
    });

    $('#passwordStepThreeSubmit').click(function(e) {
        undoHelpLoggingInFieldHighlights();
        var isValid = true;

        $('span.field-validation-error.form-error-hint').hide();

        var password = $('#password').val();
        var confirmPassword = $('#confirm-password').val();

        if (!util.isValidPassword(password)) {
            isValid = false;
            $('#passwordError').show();
        }

        if (!confirmPassword) {
            isValid = false;
            $('#confirmPasswordError').show();
        }

        if (util.showConfirmFieldError(password, confirmPassword)) {
            isValid = false;
            $('#passwordMismatchError').show();
            $('#confirmPasswordMismatchError').show();
        }

        if (isValid) {
            undoHelpLoggingInFieldHighlights();
            $('javascriptValidationSummary').remove();
        } else {
            e.preventDefault();
            highlightHelpLoggingInFields();
            createValidationSummary("passwordReset3");
        }
    });

    $('#usernameRecoverySubmit').click(function(e) {
        undoHelpLoggingInFieldHighlights();
        var isValid = true;

        $('span.field-validation-error.form-error-hint').hide();

        var firstName = $('#first-name').val();
        var lastName = $('#last-name').val();
        var monthOfBirth = $('#date-month').val();
        var dayOfBirth = $('#date-day').val();
        var yearOfBirth = $('#date-year').val();
        var emailAddress = $('#email');
        var membershipIdField = $('#membership');
        var monthDayRegex = /^\d{1,2}$/;
        var yearRegex = /^\d{4}$/;
        var membershipId = $('#membership').val();

        if (!firstName) {
            isValid = false;
            $('#firstNameError').show();
        }

        if (!lastName) {
            isValid = false;
            $('#lastNameError').show();
        }

        if (monthOfBirth !== null) {
            monthOfBirth = $.trim(monthOfBirth);
        }
        if (dayOfBirth !== null) {
            dayOfBirth = $.trim(dayOfBirth);
        }
        if (yearOfBirth !== null) {
            yearOfBirth = $.trim(yearOfBirth);
        }

        if (!monthOfBirth
            || !monthDayRegex.test(monthOfBirth)
            || monthOfBirth > 12
            || monthOfBirth < 1
            || !dayOfBirth
            || !monthDayRegex.test(dayOfBirth)
            || dayOfBirth > 31
            || dayOfBirth < 1) {
            isValid = false;
            $('#dateOfBirthError').show();
        }

        if ($('#date-year').length > 0) {
            var maxYear = new Date().getFullYear();
            if (!yearOfBirth
                || !yearRegex.test(yearOfBirth)
                || yearOfBirth > maxYear
                || yearOfBirth < 1900) {
                isValid = false;
                $('#dateOfBirthError').show();
            }
        }

        if (emailAddress.length > 0) {
            if (!util.isValidEmail(emailAddress.val())) {
                isValid = false;
                $('#caregiverEmailError').show();
            }
        }

        if (membershipIdField.length > 0) {
            if (!membershipId) {
                isValid = false;
                $('#membershipIdError').show();
            }
        }

        if (isValid) {
            undoHelpLoggingInFieldHighlights();
            $('javascriptValidationSummary').remove();
        } else {
            e.preventDefault();
            highlightHelpLoggingInFields();
            createValidationSummary("usernameRecovery");
        }
    });
});
